"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagesMock = void 0;
exports.languagesMock = [
    { locale: 'es-ES', label: 'Spanish' },
    { locale: 'en-US', label: 'English' },
    { locale: 'ca-ES', label: 'Catalan' },
];
//# sourceMappingURL=language.js.map